import { inject, Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
} from '@angular/common/http';
import { from, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { PlatformService } from '../services/platform.service';
import { AuthStateService } from '../services/auth-state.service';
import {jwtDecode} from 'jwt-decode';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly platformService = inject(PlatformService);
  private readonly router = inject(Router);
  private readonly injector = inject(Injector);
  constructor(private auth: AuthStateService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (!this.platformService.browser()) return next.handle(req);

    return from(import('@auth0/auth0-angular'))
        .pipe(
          map((module) => module.AuthService),
          switchMap((AuthService) => {
            const service =  this.injector.get(AuthService);
            return service.idTokenClaims$;
          }),
          switchMap((claims) => {
            const idToken = claims?.__raw; // Get the id_token from the claims
            if (idToken) {
              // Decode and check expiration
            // const decoded: any = jwtDecode(idToken);
            // const now = Math.floor(Date.now() / 1000);
            // if (decoded.exp && decoded.exp < now) {
            //   console.log('Token expired, redirecting to login');
            //   // Token expired, redirect to login
            //   from(import('@auth0/auth0-angular')).subscribe((module) => {
            //     const AuthService = module.AuthService;
            //     const authService = this.injector.get(AuthService);
            //     authService.loginWithRedirect({
            //       authorizationParams:{
            //         screen_hint: 'login',
            //       },
            //       appState: { target: '/callback' }
            //     });
            //   });
            //   return throwError(() => new Error('Token expired'));
            // }
              const clonedReq = req.clone({
                //withCredentials: true,
                setHeaders: {
                  Authorization: `Bearer ${idToken}`,
                },
              });
              return next.handle(clonedReq);
            }
            return next.handle(req);
          }),
          catchError((err) => {
            if (err.status === 401) {
              this.router.navigate(['/']);
            }
            console.error('Error in interceptor:', err);
            return throwError(() => new Error(err));
          }),
        );

  }
}
